import validateSeller from "./validate";

export default validateSeller;
